import { DataLayer } from "@sazka/utils/data-layer";

// DL2.10 Main page of Sazka Klub
export function dataLayerHomepage() {
    DataLayer.push({
        page: {
            type: "sazkaklub.home",
            kind: "sazkaklub.home",
            verticalCode: "sazkaklub",
            verticalCodeStrict: "sazkaklub",
            gameCode: "no_game",
            gameCodeStrict: "no_game",
        },
        event: "pageReady",
    });
}
